import { NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";

import { AlternatesModule } from "@hermes/fragments/alternates";
import { BackToGridService } from "@hermes/fragments/product-utils";
import { OriginCheckerService } from "@hermes/utils-generic/services/origin-checker";

import { GridAnalyticsEffects } from "./effects/grid-analytics.effects";
import { GridEffects } from "./effects/grid.effects";
import { GridFacade } from "./facades/grid.facade";
import { GTMHelper } from "./helpers/gtm.helper";
import * as fromGrid from "./reducers/grid.reducer";
import { CategoryService } from "./services/category/category.service";
import { FilterChangedService } from "./services/filter-changed-service/filter-changed.service";
import { GridAnalyticsService } from "./services/grid-analytics-service/grid-analytics.service";
import { GridPageHeadService } from "./services/grid-page-head/grid-page-head.service";
import { MerchandisingService } from "./services/merchandising/merchandising.service";
import { UrlManagerService } from "./services/url-manager-service/url-manager.service";
import { UserStateModule } from "@hermes/states/user";

@NgModule({
    imports: [
        EffectsModule.forFeature([GridEffects, GridAnalyticsEffects]),
        StoreModule.forFeature(fromGrid.gridFeatureKey, fromGrid.reducer),
        AlternatesModule,
        UserStateModule,
    ],
    providers: [
        CategoryService,
        FilterChangedService,
        GridPageHeadService,
        GridFacade,
        GridAnalyticsService,
        GTMHelper,
        MerchandisingService,
        OriginCheckerService,
        BackToGridService,
        UrlManagerService,
    ],
})
export class GridFiltersStateModule {}
